export default __webpack_public_path__ + "static/0308-fb17cc796953877a170b1b918183203d.png";